<section id="content" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang.servicing}}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.Servicing_List">{{lang.servicing}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.Servicing_List">{{ lang.listofequipment }}</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation"  [ngClass]="selectedTab === 'list' ? 'active' : 'none'"><a href="#listTab" aria-controls="feedTab" role="tab"
                      data-toggle="tab">{{ lang?.list }}</a></li>
                  <li role="presentation" [ngClass]="selectedTab === 'maintenanceTab' ? 'active' : 'none'"><a href="#maintenanceTab" aria-controls="maintenanceTab" role="tab"
                      data-toggle="tab">{{ lang?.maintenancePlanning }}</a></li>
                </ul>
                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane"  [ngClass]="selectedTab === 'list' ? 'active' : 'none'" id="listTab">
                    <div class="row p-10">

                      <div class="col-sm-3" style="width: 20%;">
                        <div class="social-icons">

                          <a class="plus-add" (click)="addServicing()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4" title="Export">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>


                          <a class="plus-import" data-toggle="modal" data-target="#datatableExport2" data-action="show"
                            data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Import">
                            <span class="glyphicon glyphicon-import"></span>
                          </a>

                          <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Duplicate">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()" 
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Erase">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>

                      <div class="col-sm-3" style="width: 20%;">
                        <ng-multiselect-dropdown [placeholder]="lang?.select_type" [data]="dropdownList"
                          [(ngModel)]="filter1" [settings]="dropdownSettings" (onSelect)="datatableFilterAction()"
                          (onDeSelect)="datatableFilterAction()" 
                          (onSelectAll)="datatableFilterAction($event)" (onDeSelectAll)="datatableFilterAction($event)">
                        </ng-multiselect-dropdown>
                      </div>

                      <div class="col-sm-3" style="width: 20%;">
                        <ng-multiselect-dropdown [placeholder]="lang?.select_location" [data]="dropdownList1"
                          [(ngModel)]="filter2" [settings]="dropdownSettings1"
                          (onSelect)="datatableFilterAction($event)" (onDeSelect)="datatableFilterAction()"
                          (onSelectAll)="datatableFilterAction($event)" (onDeSelectAll)="datatableFilterAction($event)">
                        </ng-multiselect-dropdown>
                      </div>

                      <div class="col-sm-3" style="width: 20%;">
                        <ng-multiselect-dropdown [placeholder]="lang?.select_responsible" [data]="dropdownList2"
                          [(ngModel)]="filter3" [settings]="dropdownSettings2"
                          (onSelect)="datatableFilterAction($event)" (onDeSelect)="datatableFilterAction()"
                          (onSelectAll)="datatableFilterAction($event)" (onDeSelectAll)="datatableFilterAction($event)">
                        </ng-multiselect-dropdown>
                      </div>


                      <div class="col-sm-3" style="width: 20%;">
                       <ng-multiselect-dropdown [placeholder]="lang?.select_status" [data]="dropdownList3"
                          [(ngModel)]="filter4" [settings]="dropdownSettings3"
                          (onSelect)="datatableFilterAction($event)" (onDeSelect)="datatableFilterAction()"
                          (onSelectAll)="datatableFilterAction($event)" (onDeSelectAll)="datatableFilterAction($event)">
                        </ng-multiselect-dropdown>
                      </div>
                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ lang.sno }}</th>
                            <th>{{ lang.description }}</th>
                            <th>{{ lang.type }}</th>
                            <th>{{ lang.matricolaNumberPlate }}</th>
                            <th>{{ lang.factoryNumber }}</th>
                            <th>{{ lang.brand }}</th>
                            <th>{{ lang.model }}</th>
                            <th>{{ lang.dateofCommissioning }}</th>
                            <th>{{ lang.location }}</th>
                            <th>{{ lang.responsible }}</th>
                            <th style="display: none;">{{ lang.attachments }}</th>
                            <th>{{ lang.maintenancePlans }}</th>
                            <th>{{ lang.maintenanceStatus }}</th>
                            <th>{{ lang.status }}</th>
                            <th>{{ lang.photo }}</th>
                            <th>{{ lang.action }}</th>
                          </tr>
                        </thead>
                        <tbody dragula="records" [(dragulaModel)]="records">
                          <tr *ngFor="let record of records let i = index" id="{{record.serviceId}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td><a [routerLink]="['/'+AppFrontRoutes.SERVICING_VIEW+'/'+record.serviceId]"
                                class="blue_action">{{record.service_disp}}</a></td>
                            <td>{{record.service_type}}</td>
                            <td>{{record.service_no_plate}}</td>
                            <td>{{record.service_fact}}</td>
                            <td>{{record.service_brand}}</td>
                            <td>{{record.service_model}}</td>
                            <td>{{record.service_doc}}</td>
                            <td>{{record.service_location}}</td>
                            <td>{{ record.responsible | nl2br}}</td>
                            <td style="display: none;">{{ record.attachments }}</td>
                            <td class="multi_lines_text">{{record.mplans | nl2br}}</td>
                            <td class="multi_lines_text">
                              <div [innerHTML]="record.mstatus"></div>
                            </td>
                            <td>
                              <div [innerHTML]="record.status"></div>
                            </td>
                            <td><img src="{{record.img_path}}" style="width: 50px; height: 50px;"></td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="delete_action" (click)="delete(record.serviceId)"><i
                                        class="fa fa-trash"></i> {{ lang.erase }}</a></li>
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="view_action" (click)="duplicate(record.serviceId)"><i
                                        class="fa fa-files-o fa-fw text-red"></i> {{ lang.duplicate }}</a></li>
                                  <!-- <li><a class="blue_action"><i class="fa fa-edit"></i> {{ lang.modify }}</a></li> -->
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="edit_action" (click)="editServicing(record.serviceId)"><i
                                        class="fa fa-edit"></i> {{ lang.modify }}</a></li>
                                  <!-- <li><a class="blue_action"><i class="fa fa-eye"></i> {{ lang.view }}</a></li> -->
                                  <li><a [routerLink]="['/'+AppFrontRoutes.SERVICING_VIEW+'/'+record.serviceId]"
                                      class="blue_action"><i class="glyphicon glyphicon-eye-open"></i> {{lang.view}}</a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>

                          
                        </tbody>

                      </table>
                    </div>
                  </div>

                  <div role="tabpanel" class="tab-pane" (click)="changeDetector.detectChanges();triggerSearch();"  [ngClass]="selectedTab === 'maintenanceTab' ? 'active' : 'none'" id="maintenanceTab">
                    <div class="row p-10">

                      <div class="col-sm-3">
                        <div class="social-icons">

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport3"
                            data-options="splash-2 splash-ef-4" title="Export">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete1()" title="Delete" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                          <a class="plus-export" (click)="setPageView('calendar')">
                            <span class="glyphicon glyphicon-calendar"></span>
                          </a>

                        </div>
                      </div>

                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="search"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>

                    </div>

                    <div class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions2" class="table-striped table-sm row-border hover"
                        id="table2">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ mLang.sno }}</th>
                            <th>{{ mLang.equipmentDescription }}</th>
                            <th>{{ mLang.matricolaNumberPlate }}</th>
                            <th>{{ mLang.factoryNumber }}</th>
                            <th>{{ mLang.brand }}</th>
                            <th>{{ mLang.model }}</th>
                            <th>{{ mLang.referringPlancode }}</th>
                            <th>{{ mLang.planDescription }}</th>
                            <th>{{ mLang.executionDate }}</th>
                            <th>{{ mLang.daysleft }}</th>
                            <th>{{ mLang.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let mdata of maintenanceData let i = index" id="{{mdata.ordinaryId}}"
                            style="color: red;">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td><a [routerLink]="['/'+AppFrontRoutes.SERVICING_VIEW+'/'+mdata.service_id]"
                                class="blue_action" style="color: red;">{{mdata.service_disp}}</a></td>
                            <td>{{mdata.service_no_plate}}</td>
                            <td>{{mdata.service_fact}}</td>
                            <td>{{mdata.service_brand}}</td>
                            <td>{{mdata.service_model}}</td>
                            <td>{{mdata.plan_code}}</td>
                            <td>{{mdata.plan_description}}</td>
                            <td>{{mdata.date_exe}}</td>
                            <td>{{mdata.missing_days}}</td>
                            <td>
                              <div class="btn-group dropup">
                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>
                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="blue_action"
                                      (click)="addMaintenance(mdata.ordinaryId,mdata.service_id,mdata.servicing_plan_id)"><i
                                        class="fa fa-clone"></i> {{ mLang.insertMaintenance }} </a></li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>




                  </div>

                </div>

              </div>



              <div role="tabpanel" *ngSwitchCase="'calendar'">

                <div class="row p-10">

                  <div class="col-sm-9">
                  </div>

                  <div class="col-sm-3">
                    <div class="social-icons">
                      <a class="plus-export" (click)="setPageView('list')">
                        <span class="glyphicon glyphicon-list"></span>
                      </a>
                      <a class="plus-export" (click)="setPageView('calendar')">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </a>
                    </div>
                  </div>

                </div>

                <app-servicing-calendar></app-servicing-calendar>
              </div>



            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ lang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{ lang?.dataImport }}</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a href="http://vmi313621.contaboserver.net/Software_backend/uploads/csv_files/template_servicing.csv" download="">{{ lang?.downloadCsv }}</a></font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">{{ lang?.save }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ mLang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> {{ mLang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ mLang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
<script type="text/javascript">

</script>